import { GlobalStyleContent, NotificationsProvider } from "@elearning-platform/ui";
import React from "react";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter } from "react-router-dom";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { Provider } from "react-redux";

import "./helpers/yupExtensions";

import { GlobalStyle } from "./theme/global";
import { store } from "./store";
import i18n  from "./translations/i18n";

import { UserRoleName } from "./userContext/userContext.constants";
import { Color } from "./theme/colors";
import App from "./app/app";
import { AppConfig } from "./appConfig";
import * as Modules from "./modules";

import { PersistGate } from './components/persistGate/persistGate.component';
import { AxiosInterceptor } from './app/axiosInterceptor/axiosInterceptor.component';
import 'react-big-calendar/lib/css/react-big-calendar.css';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css';

Modules.bootstrap(AppConfig.modules);

store.subscribe(() => {
  const { appSettings, common, userContext } = store.getState();
  const currentBrandId = appSettings.currentBrand;
  if (!currentBrandId) return;
  const brand = appSettings.brands.concat(common.brands).find((brandItem) => brandItem?.id === currentBrandId);
  const userData = userContext.data.user;

  if (userData?.role.name === UserRoleName.Onboarding) {
    Color.brandBasic = Color.blue;
  } else {
    Color.brandBasic = brand && brand.color ? `#${brand.color}` : Color.brandBasic;
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    }
  },
});

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <NotificationsProvider>
              <GlobalStyleContent />
              <GlobalStyle />
              <AxiosInterceptor>
                <PersistGate>
                  <App />
                </PersistGate>
              </AxiosInterceptor>
            </NotificationsProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </Provider>
    </I18nextProvider>
  </React.StrictMode>
);
